module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow</title><path d=\"M49.1,22.61,32.57,2a4.18,4.18,0,0,0-5.81-.65,4.3,4.3,0,0,0-.65,5.81l11.15,14H-.07v8.26H37.26L26.11,43.26a4.37,4.37,0,0,0,.65,5.82,4.12,4.12,0,0,0,5.81-.65L49.1,27.77a3.54,3.54,0,0,0,.9-2.58A5.16,5.16,0,0,0,49.1,22.61Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 7Hhe
// module chunks = 1